// Module
var code = "<div :class=\"['topHeader', { '-loading': isLoading }]\"> <cLogo :brand=\"brand\" :headline=\"t('logo_store')\"/> <div v-if=\"showSignIn\" class=\"topHeader_item\"> <cSvg height=\"12\" href=\"#signin\" width=\"14\"/> </div> </div> ";
// Exports
export default code;